import { GlobalMainHeaderComponent } from './global-main-header/global-main-header.component';

export const containers: any = [GlobalMainHeaderComponent];

export * from './global-main-header/global-main-header.component';
